module.exports = __webpack_public_path__ + "img/gioco-quiz.2627dcb7.jpg";